import { FormField, FormSelect } from '@/components';
import { useTranslation } from 'react-i18next';
import type { ContactFormData } from '../models';
import { FormSection } from '@/components/FormSection';

interface CompanyContactSectionProps {
    formData: ContactFormData;
    onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
}

export function CompanyContactSection({ formData, onChange }: CompanyContactSectionProps) {
    const { t } = useTranslation();

    return (
        <FormSection icon="contact" title="Ansprechpartner">
            <div className="grid sm:grid-cols-2 gap-3 sm:gap-3">
                <FormSelect
                    labelKey="companyAdmin.form.salutation"
                    label="Anrede"
                    name="salutation"
                    value={formData.salutation}
                    onChange={onChange}
                    className="sm:col-span-2"
                    required
                >
                    <option value="">{t('companyAdmin.form.salutationPlaceholder')}</option>
                    <option value="mr">{t('companyAdmin.form.salutationMr')}</option>
                    <option value="mrs">{t('companyAdmin.form.salutationMrs')}</option>
                    <option value="diverse">{t('companyAdmin.form.salutationDiverse')}</option>
                </FormSelect>

                <FormField
                    labelKey="companyAdmin.form.firstName"
                    label="Vorname"
                    name="firstName"
                    type="text"
                    value={formData.firstName}
                    onChange={onChange}
                    required
                />

                <FormField
                    labelKey="companyAdmin.form.lastName"
                    label="Nachname"
                    name="lastName"
                    type="text"
                    value={formData.lastName}
                    onChange={onChange}
                    required
                />

                <FormField
                    labelKey="companyAdmin.form.dateOfBirth"
                    label="Geburtsdatum"
                    name="dateOfBirth"
                    type="date"
                    value={formData.dateOfBirth}
                    onChange={onChange}
                />

                <FormField
                    labelKey="companyAdmin.form.contactEmail"
                    label="Email"
                    name="contactEmail"
                    type="email"
                    value={formData.contactEmail}
                    onChange={onChange}
                />

                <FormField
                    labelKey="companyAdmin.form.contactPhone"
                    label="Telefonnummer"
                    name="contactPhone"
                    type="tel"
                    value={formData.contactPhone}
                    onChange={onChange}
                />
            </div>
        </FormSection>
    );
}
